module.exports = __webpack_public_path__ + "img/btc.e23c056c.png";